import { Head } from 'vite-react-ssg';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': 'https://ezcloud.ai/#website',
  url: 'https://ezcloud.ai/',
  name: 'EZ Cloud',
  description:
    'AI-powered accounts payable automation that integrates with Oracle, NetSuite, SAP, Dynamics, Yardi, and JDE.',
  publisher: { '@id': 'https://ezcloud.ai/#organization' },
  inLanguage: 'en',
};

const WebSiteSchema = () => (
  <Head>
    <script type="application/ld+json">{JSON.stringify(schema)}</script>
  </Head>
);

export default WebSiteSchema;
